const angular = require("angular");
const amt_admin = require("amt_admin").default;
const app = angular.module("ww2_analytics.retention", [amt_admin]);
var { provider_states_by_gameplay } = require('amt_admin/utils.js');

app.directive("retentionTable", require("./retention_table").default);

app.config([
  "$stateProvider",
  function($stateProvider) {
    provider_states_by_gameplay($stateProvider, {
        adult_idler: [
          'amt.ww2.retention.classic',
          'amt.ww2.retention.rolling',
          'amt.ww2.retention.first_24h',
          'amt.ww2.retention.short',
        ],
      })
      .state("amt.ww2.retention", {
        url: "/retention",
        template: "<div ui-view></div>",
        reloadOnSearch: false,
        abstract: true,
        data: {
          priority: 900,
          title: "Retention",
          role: "retention"
        },
        menu: {
          glyphicon: "screenshot",
          childs: [
            {
              state: "amt.ww2.retention.average_mission",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.mission_attempts",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.by_mission",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.classic",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.rolling",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.devices",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.first_24h",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.reactivation",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.attribution",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.churn",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.short",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.short_v2",
              glyphicon: "screenshot"
            },
            {
              state: "amt.ww2.retention.notification_request",
              glyphicon: "screenshot"
            },
          ]
        }
      })
      .state("amt.ww2.retention.average_mission", require("./average_mission").default)
      .state("amt.ww2.retention.mission_attempts", require("./mission_attempts").default)
      .state("amt.ww2.retention.by_mission", require("./by_mission").default)
      .state("amt.ww2.retention.devices", require("./devices").default)
      .state("amt.ww2.retention.first_24h", require("./first_24h").default)
      .state("amt.ww2.retention.reactivation", require("./reactivation").default)
      .state("amt.ww2.retention.attribution", require("./attribution").default)
      .state("amt.ww2.retention.churn", require("./churn").default)
      .state("amt.ww2.retention.notification_request", require("./notification_request").default)
      .state("amt.ww2.retention.short", require("./short").default)
      .state("amt.ww2.retention.short_v2", require("./short_v2").default)
      .state("amt.ww2.retention.classic", require("./classic").default)
      .state("amt.ww2.retention.rolling", require("./rolling").default);
  }
]);

export default app.name;
